var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M2.365 18.302V11.84M7.457 18.302v-9.4M12.548 18.302V11.84M17.64 18.302v-9.4M2.365 8.375 5.84 4.924c.993-.986 2.284-1.183 3.475 0 1.49 1.479 2.45 3.451 4.468 1.479.954-.932 2.864-2.917 3.857-3.903"
  })));
};
export default SvgStats;